import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { motion } from 'framer-motion';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import RefreshIcon from '@mui/icons-material/Refresh';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error Boundary caught an error:', {
      error,
      errorInfo,
      componentStack: errorInfo.componentStack
    });
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
    // ページをリロード
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            backgroundColor: 'background.default',
            padding: 2
          }}
        >
          <Paper
            component={motion.div}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            sx={{
              padding: 4,
              textAlign: 'center',
              maxWidth: 500,
              borderRadius: 3,
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)'
            }}
          >
            <ErrorOutlineIcon
              sx={{
                fontSize: 64,
                color: '#f44336',
                mb: 2
              }}
            />
            
            <Typography
              variant="h5"
              sx={{
                fontWeight: 600,
                color: 'text.primary',
                mb: 2
              }}
            >
              予期しないエラーが発生しました
            </Typography>
            
            <Typography
              variant="body1"
              sx={{
                color: 'text.secondary',
                mb: 3,
                lineHeight: 1.6
              }}
            >
              申し訳ございませんが、アプリケーションでエラーが発生しました。
              <br />
              ページを再読み込みしてから再度お試しください。
            </Typography>
            
            <Button
              variant="contained"
              onClick={this.handleRetry}
              startIcon={<RefreshIcon />}
              sx={{
                backgroundColor: '#1976d2',
                '&:hover': {
                  backgroundColor: '#1565c0'
                },
                borderRadius: 2,
                textTransform: 'none',
                fontSize: '16px',
                padding: '10px 24px'
              }}
            >
              ページを再読み込み
            </Button>
            
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <Box
                sx={{
                  mt: 3,
                  p: 2,
                  backgroundColor: 'action.hover',
                  borderRadius: 2,
                  textAlign: 'left'
                }}
              >
                <Typography variant="caption" color="text.secondary">
                  開発用エラー詳細:
                </Typography>
                <Typography
                  component="pre"
                  sx={{
                    fontSize: '12px',
                    color: '#d32f2f',
                    overflow: 'auto',
                    maxHeight: 200,
                    mt: 1
                  }}
                >
                  {this.state.error.toString()}
                </Typography>
              </Box>
            )}
          </Paper>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary; 